import { render, staticRenderFns } from "./ZRPanelGroup.vue?vue&type=template&id=c1984b5a&scoped=true"
import script from "./ZRPanelGroup.vue?vue&type=script&lang=js"
export * from "./ZRPanelGroup.vue?vue&type=script&lang=js"
import style0 from "./ZRPanelGroup.vue?vue&type=style&index=0&id=c1984b5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1984b5a",
  null
  
)

export default component.exports